import React from 'react';
import { MetricCard } from '../../../ui';
import { cn } from '../../../ui/cn';
import { WIDGET_CARD_CLASS } from './widgetAnalyticsUi';

const KpiWidget = ({ label, value, hint, accent }) => (
  <MetricCard
    label={label}
    value={value}
    hint={hint}
    accent={accent}
    className={cn(WIDGET_CARD_CLASS, 'p-5')}
  />
);

export default KpiWidget;
